export default "__VITE_ASSET__DLveXZQQ__"